/* eslint-disable @typescript-eslint/no-explicit-any */
export function extractAttributeNames(schemaArray: any) {
  const results: any[] = [];
  const seen = new Set(); // To ensure uniqueness

  function traverse(obj: any) {
    if (Array.isArray(obj)) {
      obj.forEach(traverse);
    } else if (obj && typeof obj === "object") {
      if (obj.type === "attribute" && obj.name) {
        if (!seen.has(obj.name)) {
          seen.add(obj.name);
          results.push({ label: obj.name, value: obj.name });
        }
      }

      if (obj.attributes) traverse(obj.attributes);
      if (obj.entities) traverse(obj.entities);
    }
  }

  traverse(schemaArray);
  return results;
}

function buildList(node: any, path: any): any {
  if (!node || !Array.isArray(node.attributes)) return [];

  const out = [];
  for (const child of node.attributes) {
    if (!child || !child.name || !child.type) continue;

    const childPath = `${path}.${child.name}`;

    if (child.type === "attribute") {
      out.push({
        value: childPath,
        label: child.name,
      });
    } else if (child.type === "entity") {
      out.push({
        value: childPath,
        label: child.name,
        list: buildList(child, childPath),
      });
    }
  }
  return out;
}

export function transformSchemaToOptions(schema: any) {
  if (!Array.isArray(schema)) return [];

  const result = [];
  for (const entity of schema) {
    if (!entity || entity.type !== "entity" || !entity.name) continue;
    const path = entity.name;
    result.push({
      heading: entity.name,
      list: buildList(entity, path),
    });
  }
  return result;
}

export function removeByKeyPaths(options: any, keysToRemove: any, opts = {}) {
  const { prune = false }: any = opts;
  if (!Array.isArray(options)) return [];
  const keys = new Set(
    Array.isArray(keysToRemove)
      ? keysToRemove.filter((k) => typeof k === "string" && k.trim() !== "")
      : []
  );
  if (keys.size === 0) return JSON.parse(JSON.stringify(options));

  const clone = JSON.parse(JSON.stringify(options)); // defensive copy

  function removeInList(list: any): any {
    if (!Array.isArray(list)) return [];
    const next = [];
    for (const item of list) {
      if (!item) continue;
      if (typeof item.value === "string" && keys.has(item.value)) continue; // delete

      if (Array.isArray(item.list)) {
        const child = removeInList(item.list);
        if (prune && child.length === 0) {
          // drop empty container when pruning
          continue;
        }
        next.push({ ...item, list: child });
      } else {
        next.push(item);
      }
    }
    return next;
  }

  for (const block of clone) {
    if (!block || !Array.isArray(block.list)) continue;
    block.list = removeInList(block.list);
  }
  return clone;
}
